// extracted by mini-css-extract-plugin
export default {"ticker":"NumberTicker_ticker__43DKu","digit":"NumberTicker_digit__khy6h","digitTrack":"NumberTicker_digitTrack__aelX7"};